import { render, staticRenderFns } from "./DesignationEmployees.vue?vue&type=template&id=ecb830b0&scoped=true"
import script from "./DesignationEmployees.vue?vue&type=script&lang=js"
export * from "./DesignationEmployees.vue?vue&type=script&lang=js"
import style0 from "./DesignationEmployees.vue?vue&type=style&index=0&id=ecb830b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb830b0",
  null
  
)

export default component.exports